var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { NativeModule } from "./NativeModule";
import { NativeInterface } from "./NativeInterface";
export var ScreenOrientation;
(function (ScreenOrientation) {
    ScreenOrientation["UNKNOWN"] = "UNKNOWN";
    ScreenOrientation["PORTRAIT"] = "PORTRAIT";
    ScreenOrientation["LANDSCAPE"] = "LANDSCAPE";
    ScreenOrientation["REVERSE_PORTRAIT"] = "REVERSE_PORTRAIT";
    ScreenOrientation["REVERSE_LANDSCAPE"] = "REVERSE_LANDSCAPE";
})(ScreenOrientation || (ScreenOrientation = {}));
export var ScreenRotation;
(function (ScreenRotation) {
    ScreenRotation[ScreenRotation["ROTATION_UNKOWN"] = -1] = "ROTATION_UNKOWN";
    ScreenRotation[ScreenRotation["ROTATION_0"] = 0] = "ROTATION_0";
    ScreenRotation[ScreenRotation["ROTATION_90"] = 90] = "ROTATION_90";
    ScreenRotation[ScreenRotation["ROTATION_180"] = 180] = "ROTATION_180";
    ScreenRotation[ScreenRotation["ROTATION_270"] = 270] = "ROTATION_270";
    ScreenRotation[ScreenRotation["FREE"] = -10] = "FREE";
})(ScreenRotation || (ScreenRotation = {}));
export var ConnectivityNetworkType;
(function (ConnectivityNetworkType) {
    ConnectivityNetworkType["UNKNOWN"] = "UNKNOWN";
    ConnectivityNetworkType["WIFI"] = "WIFI";
    ConnectivityNetworkType["WIMAX"] = "WIMAX";
    ConnectivityNetworkType["VPN"] = "VPN";
    ConnectivityNetworkType["BLUETOOTH"] = "BLUETOOTH";
    ConnectivityNetworkType["DUMMY"] = "DUMMY";
    ConnectivityNetworkType["ETHERNET"] = "ETHERNET";
    ConnectivityNetworkType["MOBILE"] = "MOBILE";
})(ConnectivityNetworkType || (ConnectivityNetworkType = {}));
var SystemInfoNative = /** @class */ (function (_super) {
    __extends(SystemInfoNative, _super);
    function SystemInfoNative() {
        var _this = _super.call(this) || this;
        _this.uriTriggeredEventsListener = null;
        _this.appResultListener = null;
        NativeInterface.instance.addModule(_this);
        return _this;
    }
    SystemInfoNative.prototype.getPrefix = function () {
        return 'systemInfo_';
    };
    /**
     * Create a shortcuts on the desktop of the device
     */
    SystemInfoNative.prototype.getInstalledApps = function () {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'get_installed_apps',
            params: {}
        });
    };
    /**
     * Create a shortcuts on the desktop of the device
     */
    SystemInfoNative.prototype.getAppInfo = function () {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'app_info',
            params: {}
        });
    };
    /**
     * Create a shortcuts on the desktop of the device
     */
    SystemInfoNative.prototype.launchApp = function (appPackage, options) {
        if (options === void 0) { options = undefined; }
        var self = this;
        var requestParams = {
            package: typeof appPackage === 'string' ? appPackage : appPackage.package,
            params: undefined,
        };
        if (typeof appPackage === 'object' && 'params' in appPackage)
            requestParams.params = appPackage.params;
        if (typeof options === 'string') {
            requestParams.params = options;
        }
        else if (typeof options === 'object') {
            for (var key in options)
                requestParams[key] = options[key];
        }
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'start_app',
            params: requestParams
        });
    };
    SystemInfoNative.prototype.openUrl = function (url, browserType) {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'openUrl',
            params: {
                url: url,
                browserType: browserType
            }
        });
    };
    /**
     * Create a shortcuts on the desktop of the device
     */
    SystemInfoNative.prototype.getScreenInfo = function () {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'get_screen_info',
            params: {}
        });
    };
    /**
     * Create a shortcuts on the desktop of the device
     */
    SystemInfoNative.prototype.setScreenRotation = function (rotation) {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'set_screen_rotation',
            params: {
                rotation: rotation
            }
        });
    };
    /**
     * Create a shortcuts on the desktop of the device
     */
    SystemInfoNative.prototype.getBatteryInfo = function () {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'get_battery_info',
            params: {}
        });
    };
    /**
     * Create a shortcuts on the desktop of the device
     */
    SystemInfoNative.prototype.getConnectivity = function () {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'get_connectivity',
            params: {}
        });
    };
    /**
     * Create a shortcuts on the desktop of the device
     */
    SystemInfoNative.prototype.enableBackButton = function () {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'backButton_enable',
            params: {}
        });
    };
    /**
     * Create a shortcuts on the desktop of the device
     */
    SystemInfoNative.prototype.disableBackButton = function () {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'backButton_disable',
            params: {}
        });
    };
    /**
     * Is the back button enable
     */
    SystemInfoNative.prototype.isBackButtonEnabled = function () {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'backButton',
            params: {}
        }).then(function (result) {
            return result.status;
        });
    };
    /**
     * Get the hardware/serial unique ID associated with the device
     */
    SystemInfoNative.prototype.getDeviceID = function () {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'device_id',
            params: {}
        }, 60 * 1000).then(function (result) {
            return result.deviceID;
        });
    };
    /**
     * Get a unique ID associated with the device/app/app signing key/user
     */
    SystemInfoNative.prototype.getDeviceAppId = function () {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'deviceAppId',
            params: {}
        }).then(function (result) {
            return result.id;
        });
    };
    /**
     * Get information about the device running the app
     */
    SystemInfoNative.prototype.getDeviceInfo = function () {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'device_info',
            params: {}
        }).then(function (result) {
            return result;
        });
    };
    /**
     * Set the screen brightness of the app
     * @param brightness between [0;255] OR a negative value(system default value)
     */
    SystemInfoNative.prototype.setBrightness = function (brightness) {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'set_brightness',
            params: {
                brightness: brightness
            }
        });
    };
    /**
     * Get the screen brightness of the app
     */
    SystemInfoNative.prototype.getBrightness = function () {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'get_brightness',
            params: {}
        }).then(function (result) {
            return result.brightness;
        });
    };
    /**
     * Get information about the device running the app
     */
    SystemInfoNative.prototype.getTrackingStatus = function () {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'tracking_status',
            params: {}
        }).then(function (result) {
            return result;
        });
    };
    /**
     * Get information about the device running the app
     */
    SystemInfoNative.prototype.askTrackingPermission = function () {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'tracking_authorize',
            params: {}
        }).then(function (result) {
            return result;
        });
    };
    SystemInfoNative.prototype.addWifiNetwork = function (wifis) {
        return NativeInterface.instance.request({
            name: this.getPrefix() + 'add_wifi_network',
            params: {
                wifis: wifis
            }
        }).then(function (result) {
            return result;
        });
    };
    SystemInfoNative.prototype.listenUriTriggeredEvents = function (listener) {
        this.uriTriggeredEventsListener = listener;
        return NativeInterface.instance.request({
            name: this.getPrefix() + 'startUriTriggeredEventsListener',
            params: {}
        });
    };
    SystemInfoNative.prototype.setAppResultListener = function (listener) {
        this.appResultListener = listener;
    };
    SystemInfoNative.prototype.onEvent = function (event) {
        if (event.name === this.getPrefix() + 'uriTriggered') {
            if (this.uriTriggeredEventsListener) {
                this.uriTriggeredEventsListener(event.params.uri);
            }
        }
        else if (event.name === this.getPrefix() + 'appResult') {
            if (this.appResultListener) {
                this.appResultListener(event.params);
            }
        }
    };
    return SystemInfoNative;
}(NativeModule));
export { SystemInfoNative };
//# sourceMappingURL=SystemInfoNative.js.map